import { ChatMessage, ChatMessageStruct } from '@2meters/types'
import { db } from 'api/Firebase/firebase-init'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { create } from 'zustand'
import { sendVisitorChatMessage as sendVisitorChatMessageApi } from 'api/backend/sendVisitorChatMessage'
import { markChatMessagesRead as markChatMessagesReadApi } from 'api/backend/markChatMessagesRead'

interface TicketChatStore {
  placeId: string | undefined
  appointmentId: string | undefined
  messages: ChatMessage[]
  isLoading: boolean
  subscribe: (placeId: string, appointmentId: string) => () => void
  send: (text: string) => Promise<void>
  markRead: () => Promise<void>
}

export const useTicketChat = create<TicketChatStore>((set, get) => ({
  placeId: undefined,
  appointmentId: undefined,
  messages: [],
  isLoading: false,

  subscribe: (placeId, appointmentId) => {
    set({ placeId, appointmentId, isLoading: true })

    const ref = query(
      collection(db, `places/${placeId}/tickets/${appointmentId}/chatMessages`),
      orderBy('createdAt', 'asc')
    )

    const unsubscribeFromFirestore = onSnapshot(
      ref,
      snap => {
        const messages = snap.docs.map(doc => {
          const [, msg] = ChatMessageStruct.validate(doc.data(), { coerce: true })
          return msg ?? (doc.data() as ChatMessage)
        })
        set({ messages, isLoading: false })
      },
      error => {
        console.error('Chat messages subscription error', error)
        set({ messages: [], isLoading: false })
      }
    )

    const unsubscribe = () => {
      unsubscribeFromFirestore()
      set({ placeId: undefined, appointmentId: undefined, messages: [] })
    }

    return unsubscribe
  },

  send: async (text: string) => {
    const { placeId, appointmentId } = get()
    if (!placeId || !appointmentId) return
    await sendVisitorChatMessageApi({ placeId, appointmentId, text })
  },

  markRead: async () => {
    const { placeId, appointmentId } = get()
    if (!placeId || !appointmentId) return
    await markChatMessagesReadApi({ placeId, appointmentId })
  },
}))
